import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { useTranslation } from "next-i18next";
import classnames from "classnames";
import styles from "./styles.module.scss";
import SuccessIcon from "../Icons/Success";
interface ProgressIndicatorPropsType {
  duration: number;
  text?: React.ReactNode;
  isSuccess?: boolean;
  className: React.HTMLAttributes<never>["className"];
}
function ProgressIndicator(t0) {
  const $ = _c(17);
  const {
    duration,
    text,
    isSuccess,
    className
  } = t0;
  const {
    t
  } = useTranslation();
  const [didAppear, setDidAppear] = React.useState(false);
  const t1 = `${duration}ms`;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      animationDuration: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const style = t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const timeout = window.setTimeout(() => {
        setDidAppear(true);
      }, 1);
      return () => window.clearTimeout(timeout);
    };
    t4 = [];
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  React.useEffect(t3, t4);
  let t5;
  if ($[4] !== didAppear) {
    t5 = classnames(styles.fill, {
      [styles.appear]: didAppear
    });
    $[4] = didAppear;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== style || $[7] !== t5) {
    t6 = <div className={styles.bar}><span className={t5} style={style} /></div>;
    $[6] = style;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== isSuccess || $[10] !== t || $[11] !== text) {
    t7 = isSuccess ? <div className={styles.progressSuccess}><SuccessIcon /><div className={styles.text}>{t("Erfolg!")}</div></div> : <div className={styles.text}>{text || t("Hochladen\u2026")}</div>;
    $[9] = isSuccess;
    $[10] = t;
    $[11] = text;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== className || $[14] !== t6 || $[15] !== t7) {
    t8 = <div className={className}>{t6}{t7}</div>;
    $[13] = className;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}
export default ProgressIndicator;